var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _g31, _g32, _g33, _g34, _g35, _g36, _g37;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDNegerisembilan(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1240 640",
    preserveAspectRatio: "xMidYMid slice",
    id: "svgN",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "N2",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M701.8 255.6l-2.8-5.8-2.3-2.3.3-5.3-2.8-8.4c-1.5-9.9 3.1-13 3.1-13l-.5-5.6-3.3-1c.5-4.6-.5-7.6-3.3-9.2-2.8-1.5-1.5-5.8-1.5-5.8l-2-2.8c-1.5-9.9-6.6-7.6-6.6-7.6l-2.3-2 4.3-8.4-6.4-6.4-1.8 1.3-6.8-13.3h-.2l-23.3-7.4 1 12.9-2.3.8-1.3 2.8 1.5 6.6-4.3 5.3c-2.3 4.6 2.5 6.1 2.5 6.1l.3 3.3-1.5 1.3.5 3.8s-4.6 1.3-3.8.8c.8-.5-5.3 2.5-5.3 2.5l-2.5-4.3-14-4.8c-1.8 1.3-9.2 3.1-9.2 3.1l-2.5 3.1-2 6.4c7.4 4.8-2.8 8.4-2.8 8.4l.8 2.5-1 1.5-3.1-1.5-4.1 3.1-.3 3.1-2 .5c-1-.6-2.1-.9-3.1-1l-.2 21.6v4.6l2 7.1 3.8-.3 2.3-1.5 1.3 2.8-2 1.5-2 12.2-6.4 4.6 1.3 4.8 4.6 5.6 2.9 8.4 2.9-1 3.6-.3 2-2.3 10.9 4.8 4.1-3.6.8-4.3 5.8-.8 8.9 3.8 4.3-2.3s2.4 1.6 4 1.8c1.2.2 2-.4 1.3-2.6l-2.5-6.9 1.8-2.3 4.6 1 .8-2.5 6.1-8.4 5.6-6.4 44.1-2.4z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "N3",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M773.5 255.9l-.5-2.3.3-5.3-5.1-4.1-.3-4.1-2.8-2.8s.8-1.3.5-2c-.3-.8-2-3.1-2-3.1v-8.3l-40.3-51.8-56.2-12.2 6.8 13.3 1.8-1.3 6.4 6.4-4.3 8.4 2.3 2s5.1-2.3 6.6 7.6l2 2.8s-1.3 4.3 1.5 5.8 3.8 4.6 3.3 9.2l3.3 1 .5 5.6s-4.6 3.1-3.1 13l2.8 8.4-.3 5.3 2.3 2.3 2.8 5.8-44.2 2.3-5.6 6.4 3.8 3.8 1.5-2.3 13.5 9.7 1.3-3.3 9.7 3.1-1 8.1 12.5.3 12.2-5.8 13.2 6.9s.5-3.6 3.1-4.3c2.5-.8 2-4.6 2-4.6l8.4 1.3.5 6.9-2.5.3v4.1l2.5.8-1 4.1-1.8-.8-1.3 2.3 3.8.3-.5 22.1 6.9.5 11.2-10.4 4.3.8 3.3-6.6-.8-2.8.8-6.9 2.8-6.9-3.6-5.8-1.8-2.5.3-1.8 1-3.8 1.5-1.8 4.8-.8 5.6.5 4.3-6.4-.3-4.3 1.3-2.3z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "N4",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M585.1 276l-1.3-4.8 6.4-4.6 2-12.2 2-1.5-1.2-2.9-2.3 1.5-3.8.3-2-7.1v-4.6l.2-21.6c-7.2-1.1-13.7 7.1-13.7 7.1s-2.5 7.6-3.3 9.7c-.8 2-4.1 3.3-8.4 1.5-4.3-1.8-9.9-2.8-15 .3-5.1 3.1-7.1 7.6-7.1 7.6l4.8 6.1 1.5 2-1.8 7.6 1 3.3-1.5 1-5.6-.5-6.1 5.1v2l-1.8 1.8-2.5-1-1.8-2.5-2 1.8-3.8-.5-9.4 2-8.1-1-.6 1.3 1 3.3 4.3 2.3-4.8 5.6.5 3.8 2 1.8.5 5.1-2 2.5 6.9 16.5 9.4 5.6s4.1-5.1 6.4 3.6l3.3 1.3 2 2 4.6-4.6 2 1.8 2 .3 1.5-2.3h3.6l2.5-3.1.3 4.6-.9 1.2 6.5-1 4.1-5.6 5.8-1.5-.5-2.8 2-7.4 5.1-1.5-.3-4.3 2.5-1.8 2-2.5 7.4-3.8v-2l5.6-2 3.8 3.1 3.4-1.2-2.9-8.4-4.4-5.8z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "N5",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M807.7 253.9l-42.9-28.5-.4-.6-.8-1v8.3s1.8 2.3 2 3.1c.3.8-.5 2-.5 2l2.8 2.8.3 4.1 5.1 4.1-.3 5.3.5 2.3-1.3 2 .3 4.3-4.3 6.4-5.6-.5-4.8.8-1.5 1.8-1 3.8-.3 1.8 1.8 2.5 3.6 5.8-2.8 6.9-.8 6.9.8 2.8-3.3 6.6-4.3-.8-11.2 10.4-6.9-.5.5-22.1-3.8-.3 1.3-2.3 1.8.8 1-4.1-2.5-.8v-4.1l2.5-.3-.5-6.9-8.4-1.3s.5 3.8-2 4.6c-2.5.8-3.1 4.3-3.1 4.3l-13.2-6.9-12.2 5.8-12.5-.3 1-8.1-9.7-3.1-1.3 3.3-13.5-9.7-1.5 2.3-3.8-3.8-6.1 8.4-.8 2.5-4.6-1-1.8 2.3 2.5 6.9c.6 2.2-.2 2.7-1.3 2.6l.3.7c9.2 3.6 12.2 11.4 12.2 11.4l4.3 1.5 3.6 5.1 2.5-1.5 6.9 4.8 1.3-1.5 2 2.3-.5 1.5 11 3.9 1 5.3 3.6-.8 2.8 4.1-2.8 3.3 22.4 11.9 4.8 1.3 5.6-1 .5-2.3 1.5-1.3 1.8 1.8 2.5-1.5-3.1-2.3-1.8-6.4 9.2-.5-.3 3.8 1.8.4.5-.6.5-4.1 2.3-2.8 19.6 1 2.8 2.3 8.4-.3 17 12.7 6.1-9.2.3-.4 12.7-.5 5.6-8.1-1.1-65.6z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "N6",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M885.8 320.3l1.7-5.5-1-7.8-2.8-8.1-3-4.5-1.4-2.7-3.7-1.7-.4 3.1-3.9 2.9-63.6-42.1 1.1 66-5.6 8.2-12.7.5-.3.4 6.2 7.7 7.4 6.1-6.7 9.4 11.5 9.4 1.8 7.9 5.3-2.3 7.4-4 9.4 17.5-.8 18.6h2.6l2 2.5-2 1.5 3.3 15-.8 3.9 1 .9 14 .8.3-.8 37.8-98.7z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "N7",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M834.3 403.3l2-1.5-2-2.5h-2.5l.8-18.6-9.4-17.5-7.4 4.1-5.3 2.3-1.8-7.9-11.4-9.4 6.6-9.4-7.4-6.1-6.1-7.7-6.1 9.2-17-12.7-8.4.3-2.8-2.3-19.6-1-2.3 2.8-.5 4.1-.5.6 2.1.4-.5 6.4-.5 3.6 1 2-2 4.1-2.3.3-.5-2-5.8-1.8-1.5 5.3-2.2 3.6h.9l2.8 8.1 2 2.3.3 1.5-2.8 4.3.8 9.4-2.3 2-1.8-.8.3 3.3-4.3 5.1-2.3-.5-3.1 1.5c0 3.3-3.1 5.3-3.1 5.3l-3.3-.3c-2.8 1.3-3.1 6.6-1.8 11.4 1.3 4.8-.5 5.8-3.6 8.1s-.5 5.6-.3 7.6c.3 2-8.6 5.1-8.6 5.1l8.1.8-.9 24.6 44.1-49 66.4 2.5v7.1h1l8.1 7.9 8.1-2.8 8.1 5.8 2-1.3 1.1 1.1.7-3.9-3.3-14.9z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "N8",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M734.6 336.7l.5-6.4-2.1-.4-1.8-.4.3-3.8-9.2.5 1.8 6.4 3.1 2.3-2.5 1.5-1.8-1.8-1.5 1.3-.5 2.3-5.6 1-4.8-1.3-22.4-11.9 2.8-3.3-2.8-4.1-3.6.8-1-5.3-11-3.9-.5 1.3c.5 3.8-2.5 9.4-2.5 9.4l-1 4.8 10.2.8 2.3 3.3.3 2.5 11.2 12.7h2l1.5 3.1v4.3l3.3 7.4 10.2-1.5-.3-6.4 11.5-.2 2.2-3.6 1.5-5.3 5.8 1.8.5 2 2.3-.3 2-4.1-1-2 .6-3.5z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "N9",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M546 323.2l-.3-4.6-2.5 3.1h-3.6l-1.5 2.3-2-.3-2-1.8-4.6 4.6-2-2-3.3-1.3c-2.3-8.6-6.4-3.6-6.4-3.6l-9.4-5.6-6.9-16.5 2-2.5-.5-5.1-2-1.8-.5-3.8 4.8-5.6-4.3-2.3-1-3.3.8-1.8c-3.3-9.9-18-9.9-18-9.9l1.3-4.6-4.8-1.8-1.8 1.5-1.3-3.3-6-2.1-.5 1.2-22.6 54.7 6.8 9.1-1.3 2.8 5.6 3.3 5.1-1 .5 4.8 8.1 5.1 11.9.8 3.3 5.1-4.1 3.6-2.3 5.3-.3.4 1.4-.2-3.6 12.2-1.3 1 .6 2.1 1.1-.6 5.8 3.1 1-.5 1.6-.8 3.3-2 5.1 3.6-1.8 5.1 1.8-1.3 3.1-3.8 6.4-1.5 1.8 4.8-2.3 5.6.8 10.3 3 .4 4.1.5s4.1 5.8 9.4.3l5.6-1.8 4.6 1.5h4.1l1.3-2.8 2.9.9.1-1.9-.8-1.3 1-4.3.5-4.3c-3.1-1.5-2-4.1-2-4.1-3.1-2-.3-10.2-.3-10.2l-1.3-4.6 1.3-3.6-2.3-6.6 1.8-2.3 4.1-2 .3-3.8 2-2.8-1-4.3 1.4-1.8 1-1.3z"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "N15",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M694.4 345.1h-2l-11.2-12.7-.3-2.5-2.3-3.3-10.2-.8 1-4.8s3.1-5.6 2.5-9.4l1-2.8-2-2.3-1.3 1.5-6.9-4.8-2.5 1.5-3.6-5.1-4.3-1.5s-3.1-7.9-12.2-11.4l-.3-.7c-1.6-.2-4-1.8-4-1.8l-4.3 2.3-8.9-3.8-5.8.8-.8 4.3-4.1 3.6-10.9-4.8-2 2.3-3.6.3-6.4 2.3 7.6 9.9-.8 5.8 4.3 7.6 3-.8 10.2 7.1-.8 6.4 1.8.8.5 4.6-3.3 1.3H610l-3.3 5.3 1.8 2.3v2l-4.3.3 3.3 4.1h3.8l1.5-1.3 1.8 3.8-1.2 2.6 9.1 6.3 1.3-4.1 2.5.3.5 1.5 3.8 1.3 2 2.5 3.1-1.3 2.5 2.8.3 3.3 6.5 1.7 1.1.3 3.6-.5.8-3.1 1.8-3.1.3 3.1 3.6-1 14-8.4 9.9-1.5 5.8.8 5.3-1.8 4.6-.8v-3.3l-1.4-3.2z"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "N16",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M619.9 391.9l1.5-4.8-.5-11.2-11.7-1.8c-2.5-5.6 5.3-12.5 5.3-12.5l2 2 3.1-2.5-6.9-6.4.8-1.7 1.2-2.6-1.8-3.8-1.5 1.3h-3.8l-3.3-4.1 4.3-.3v-2l-1.8-2.3 3.3-5.3h1.5l3.3-1.3-.5-4.6-1.8-.8.8-6.4-10.2-7.1-3 .8-4.3-7.6.8-5.8-7.6-9.9-3.8-3.1-5.6 2v2l-7.4 3.8-2 2.5-2.5 1.8.3 4.3-5.1 1.5-2 7.4.5 2.8-5.8 1.5-4.1 5.6-6.5 1-1.4 1.8 1 4.3-2 2.8-.3 3.8-4.1 2-1.8 2.3 2.3 6.6-1.3 3.6 1.3 4.6s-2.8 8.1.3 10.2c0 0-1 2.5 2 4.1l-.5 4.3-1 4.3.8 1.3-.1 1.9-.1 2.7-2.5 2.5.5 3.8s-5.3 6.1 1.8 10.2l4.1 3.8 2.5-2 2.8.5 2.3-4.1 1-4.6.3-1 1.3 1.8 2.5-2.8 1.3-2.8 3.6 2.8.3-2 9.4.3 1.5-.5 5.1 3.6-4.8 18-3.1 1.8 2.5 2.5s.5 4.1.3 7.1c-.3 3.1 1.5 8.4 6.1 7.6l2 2.3h1.8l4.1 2.8s.8 7.4 7.9 5.8l.7-.3 1.3-22.5 3.8 1 1.5-5.1 2.8-2.2-1.6-5.4 6.4-4.6 1.3-2.8 4.3-2.5c5.8-2 8.1-5.6 8.1-5.6l-3.5-.4z"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "N13",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M506.8 367.5l-1.8-4.8-6.4 1.5-3.1 3.8-1.8 1.3 1.8-5.1-5.1-3.6-3.3 2-1.6.8-.2 1.9-1.9.8.7 1.9-.3.8 1.9 1.2.3 2.9-1-.2-.5 1.9-3-1.9-1.5 3.6 2.2 1.2 1 2 .8 1.6 2.2-1.4 1.7 2.9 1.4-2.5v-1.5s2.5-2 5.1-3.2c2.5-1.2 6.9-.7 6.9-.7l-.8 2.4-2.7-.8-1.5 2 2.4.9-.8 1.9 1.8 2.2v-.4l5.6.7-.8-10.3 2.3-5.8z"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "N12",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M485.8 370.1l-1.9-1.2.4-.8-.7-1.9 1.9-.8.2-2-1 .5-5.8-3-1.2.5-1.9 1 2.8 7.9-4.6 2.8.5 2.8 2.8-.5-1 3.9 2.6 1.9-1.1 3.8 1.1.5 1.6-4.2 2.1-.9.7-.8-1.1-2-2.2-1.2 1.6-3.6 3 1.9.5-1.9 1 .2z"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "N17",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M726.7 363.7l-.3-1.5-2-2.3-2.8-8.1-12.5.3.3 6.4-10.2 1.5-3.3-7.4v-1.1l-4.6.8-5.3 1.7-5.8-.8-9.9 1.5-14 8.4-3.6 1-.3-3.1-1.8 3.1-.8 3.1-3.6.5-1.1-.3-1.2 5.4.5 5.6.3 3.8 3.1 1-.3 2.3h-3.1l1.3 3.8-3.1.8-.3 2 3.1 2.5 1.8-.5 1.3 1.8-.5 1.7-.8 3.1 6.6 1.8 11.2-6.4.5-9.1 13.5-2.8 1.8 5.1h3.8l.3-4.8 4.6 4.1 7.6.3 5.1-4.6 8.8 4.6c0-.3.1-.5.1-.8l3.1-1.5 2.3.5 4.3-5.1-.3-3.3 1.8.8 2.3-2-.8-9.4 2.9-4.4z"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "N18",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M638.5 362.4l-2.5-2.8-3.1 1.3-2-2.5-3.8-1.3-.5-1.5-2.5-.3-1.3 4.1-9.1-6.3-.8 1.7 6.9 6.4-3.1 2.5-2-2s-7.9 6.9-5.3 12.5l11.7 1.8.5 11.2-1.5 4.8 3.3.5s-2.3 3.6-8.1 5.6l-4.3 2.5-1.3 2.8-6.4 4.6 1.6 5.4.7-.6 3.1 2.8 11.4-12.5 2.8 5.3 16.5-8.9 2.8-3.3 2 .3 4.1 1.2.5-1.7-1.3-1.8-1.8.5-3.1-2.5.3-2 3.1-.8-1.3-3.8h3.1l.3-2.3-3.1-1-.3-3.8-.5-5.6 1.2-5.4-6.5-1.7-.4-3.4z"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "N19",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M702.3 384.3l-5.1 4.6-7.6-.3-4.6-4.1-.3 4.8H681l-1.8-5.1-13.5 2.8-.5 9.1-11.2 6.4-6.6-1.8.8-3.1-4.1-1.2-2-.3-2.8 3.3-16.5 8.9-2.8-5.3-11.4 12.5-3.1-2.8-.7.6-2.8 2.2-1.5 5.1-3.8-1-1.3 22.5 3.1-1.5 1.8 2.8-1.5 1 4.3 5.6 4.3 3.3v3.1l-1.5 1.5 2 4.3.5 1.5 4.8 6.9s5.6.5 5.3 4.6l1 2.8.4 2.8c2.6-.2 5.5 2 5.5 2l1.3-2 6.1 3.8 3.6-5.1 1.5 1.8 3.1-.8 35.6 3.3 9.4-1.5 2.3-5.8.5-11.7-3.1-.3 12.4-13.7.9-24.6-8.1-.8s8.9-3.1 8.6-5.1c-.3-2-2.8-5.3.3-7.6 3.1-2.3 4.8-3.3 3.6-8.1-1.3-4.8-1-10.2 1.8-11.4l3.3.3s2.6-1.7 3-4.6l-9.2-4.6z"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "N20",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M439.7 387.1l-.5-13.5 1.8-1.3 7.3 2.3 3.9-1.8-.8-4.3 3.8-10.9 3.8.2.5-2.3-5-1-2.8 1.8-5.9.2-15.2-7.8-5.9 9.4-7.6-2.6-2.6-6.1 2.1-1.8-3.3-6.6-4.6 2.3-.3 1-7.3-3.8-1.3 1-8.1-3.3-11.7 3.2 2.7 41.1v.5l8.7-.3 7.4 23.9-.3 4.6 18.6.8v-.1l4-11.6 4.1-3.3h9.7l3.5 3.3-.2-12.2z"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "N21",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M478.1 384.8l1-3.8-3.3-2.5-2 4.6-7.4-5.1-2.3.3-1.3-4.1-2.5-.3.5-5.1-9.4-.3.8 4.3-3.8 1.8-7.4-2.3-1.8 1.3.5 13.5-1.5 1 .3 12.2-.8 2.8 6.1 5.9 4.1-1.8 13.5 2v-3.1l2.5 1.3 1-1.5 2.5 2.3 3.2-3.5.3-.4v-2.8s-2.3-2-3.6-1.8l.8-2 1.5-.3.5-2.5 2-1.8 1.5 1.3v-3.8h3.8l2.1-5-1.4-.8z"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "N11",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M475.8 362.4l1.9-1-.6-2.1 1.2-1 3.6-12.2-1.3.2-5.8.8-1.3 4.4-1-.8-6.1 1.3-6.9 3.5-.8.2.6.1-.5 2.3-3.8-.3-3.9 10.9 9.5.3-.6 5.1 2.6.2 1.3 4.1 2.2-.2 7.4 5 2-4.5.8.6 1-3.9-2.8.5-.5-2.8 4.6-2.8z"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "N23",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M488.3 404.1l.2-1.8.5-3v-4.4l-1.8-.8-1.7 1.1-3.6 1.3-.8 1.5.6 1.3-7.2 1.5-2.5 5.1-1.4-1.2-3.2 3.4-2.5-2.2-1 1.5-2.6-1.3v3.1l-13.5-2.1-4 1.8.5.5v4.3h6.8l.3 3.3h6.1v-2l4.3-2.3 4.9 1.6.5 4.5h3.3l-.3-3.3 4.6-.2.5-2.8h4.1l1.2 2 8.4.5-.2-2.3 1.2-1.5 2.1 2.8 1.2-1.8.8.1-1.8-5.2z"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "N25",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M526.2 436.9l-1.6-.5-.5-15.9 3.5-8.4 2.2.3 9.4-11.3c-6-4.1-1-9.7-1-9.7l-.5-3.8 2.5-2.5.1-2.7-2.9-.9-1.3 2.8H532l-4.6-1.5-5.6 1.8c-5.3 5.6-9.4-.3-9.4-.3l-4.1-.5-8.6-1-.5 5.3-1.3 1-1-1.1-2.6 8.2 1.5-1 1.5 3.1 7.6 6.1-1.8 2.8 2.3 4.1 1.5 4.1-1.8 1.3-1.3-1-1-2.3-9.9-.8-1.3 1.8-2-2.8-1.3 1.5.3 2.3v7.3h8v8.1h3.8l3.5 6.7-2.4.5-.3 8.4h4.9v8.4h-4v10l14.3.6h9.7v-28.5z"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "N14",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M498.7 379.1l-2.4-.9 1.5-2 2.7.8.8-2.4s-4.4-.5-6.9.7-5.1 3.2-5.1 3.2v1.5l-1.4 2.5-1.7-2.9-2.2 1.4-.8-1.6-.7.9-2 .8-1.7 4.3 6.3 3.3 2.8-.5 1.8 1.3 2.5-1.3v-2h3.1l1.6 1.7 1 1.1 1.3-1 .5-4.9-1.8-2.2.8-1.8z"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "N24",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M505.8 410.9l-2.3-4 1.8-2.8-7.6-6.1-1.6-3.1-1.5 1 2.6-8.1-1.6-1.8h-3v2.1l-2.6 1.2-1.7-1.2-2.8.5-1.7-.9-.4 2.1 3.1 1.3-1.3 2.1 2 .9 1.8.8v4.4l-.5 3-.2 1.8 4 3 1.8 5.2 9.2.7 1 2.3 1.2 1 1.8-1.3z"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "N22",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M473.8 390.6v3.8l-1.5-1.3-2 1.8-.5 2.5-1.5.3-.8 2c1.3-.3 3.6 1.8 3.6 1.8v2.8l-.3.4 1.3 1.2 2.5-5.1 7.1-1.5-.5-1.3.8-1.5 3.6-1.3 1.7-1.1-2-.9 1.3-2-3.1-1.3.3-2.1-4.1-2.1-2.1 5h-3.8z"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "N26",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M548.1 493.9l2.7-1.6 8.9.8 1.4-5.4-1.6-1.1 5.9-10.3-.3-3 1.9-.3 5.1-5.1-4.6-2.7 1.1-2.2-1.9-3.5 1.1-1.9 1.3.8 2.7-4.6-1.4-3.5 4-5.9-.3-5.4-1.1-4.9 2.5-3.2c-2.3-1.4-3.2-4.8-3-7.1.3-3-.3-7.1-.3-7.1l-2.5-2.5 3.1-1.8 4.8-18-5.1-3.6-1.5.5-9.4-.3-.3 2-3.6-2.8-1.3 2.8-2.5 2.8-1.3-1.8-.3 1-1 4.6-2.3 4.1-2.8-.5-2.5 2-4.1-3.8c-.3-.2-.5-.3-.7-.5l-9.4 11.3-2.2-.3-3.5 8.4.5 15.9 1.6.5v28.4h-9.7l-.5 14.2h10.4l.2 26.6 23.1-5-1.3-7z"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "N27",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M506.2 454.7v-8.3h-4.8l.2-8.4 2.5-.5-3.5-6.8h-3.8v-8.1h-8v-7.3l-8.4-.5-1.3-2.1H475l-.5 2.8-4.5.3.2 3.3h-3.3l-.5-4.6-4.8-1.5-4.4 2.3v2h-6.1l-.2-3.3H444v-4.3l-6.6-6.4.8-2.8-3.6-3.3H425l-4.1 3.3-4 11.6 4.2 8.8 6.1 3.3 4.9-13.5 12.2 7.6-.5 3.6-1 .2-3.6 11.5h11.2v2.5l10.7-.2.5 10.4h6.1l-1.3 3.3 4.6.5-1.8 15.5 2.3-1 3.8 4.6-.5 6.6-1.8.2.8 3.6 20.8.2-.2-4.3 1.7-1.3v1.8h3.1l-2.3-9.4-5.6-2.3 10.9.5v-10.1z"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    id: "N28",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M625.5 502l-1-2.8-4.6-3.1-3.8-4.1.5-2-1-2c.3-5.3 2.2-6.9 4.2-7.1l-.4-2.8-1-2.8c.3-4.1-5.3-4.6-5.3-4.6l-4.8-6.9-.5-1.5-2-4.3 1.5-1.5v-3.1l-4.3-3.3-4.3-5.6 1.5-1-1.8-2.8-3.8 1.8c-7.1 1.5-7.9-5.8-7.9-5.8l-4.1-2.8h-1.8l-2-2.3c-1.2.2-2.2 0-3.1-.6l-2.5 3.2 1.1 4.9.3 5.4-4 5.9 1.4 3.5-2.7 4.6-1.3-.8-1.1 1.9 1.9 3.5-1.1 2.2 4.6 2.7-5.1 5.1-1.9.3.3 3-5.9 10.3 1.6 1.1-1.4 5.4-8.9-.8-2.7 1.6 1.6 7.3-23.1 5 .3 30.9 2 .9-.4 5 1.8 3.2 3.2.5 2.3.9 1.8-2.3-1.4-3.2 2.7-2.7 3.2.9 1.4-9.1 1.8-6.3 6.3 4.1 2.3-1.4 3.6 4.5 16.8-8.2 13.1 2.3 18.6-21.7 8.4 5.1 2.3 2.3 3.6 1.4 1 .6 2-4.9-1.5-1.8 3.5-5.3z"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    id: "N29",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M402.8 460.9l1.6-3.2 1.6-.5-2.4-3.2c-4 6.5-5.1-2.7-5.1-2.7l-1.1-2.2 12.1-.5 1.6 1.6 4.3-16.2 4-.3 1.6-4.1-1.1-2.2 3-5.6-1.9-1.1-4.3-8.7v.1l-18.6-.8.3-4.6-7.4-23.9-8.7.3.6 9.7-4.4 3.1v3.4l-2 2.4 1.7 1.7-1 2-2.7-1-4.1 6.1 3.1 3.1 1 5.8-7.5 3.4-4.4 6.8 2.4 3.4v3.4l-1 3.4-3.1-2.4-9.9 6.5-1 2.4 3.7 2.4 1 2.7 10.2 1 3.1-3.7 5.4-1.4 5.1-1 5.8 4.1 7.1 3.4.3 4.1 3.1 2 .5.4c2.8-4.7 7.5.6 7.5.6z"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    id: "N30",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M467.7 446.3h-6.1l-.5-10.4-10.7.3v-2.5h-11.2l3.6-11.4 1-.3.5-3.6-12.2-7.6-4.8 13.5-4.2-2.2-3 5.6 1.1 2.2-1.6 4.1-4 .3-4.3 16.2-1.6-1.6-12.1.5 1.1 2.2s1.1 9.2 5.1 2.7l2.4 3.2-1.6.5-1.6 3.2s-4.7-5.4-7.3-.5l4.6 3.6.3 6.1-2.7 4.1 3.1.7 1.7 3.1-1 2.2 2.5.2 2.4-9.2 6.2 1.1v1.9l11.3.8 2.7 4.3 9.4.3.3-11.3 4-.5.3-3h-4.3l-1.3-1.9-3-.5-.5-5.4s4.9-3.5 6.7-.5l1.9-.5 7.6-7 7-.5 9.7 3 3-1.5-1-.1 1.1-3.9z"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    id: "N31",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M440.9 533.8l-1.9-.8 1.4-3.2 2.7-.3 1.1-4.3-7.8-10.5-2.7-3.2 3.5-3.2 2.4 4.6 4.3-1.9-.3 3.8 6.5-5.1 3.8 1.3.8 5.4.5 8.4 6.2-.3.8-3.5 3.2-.8.3-3.8 11.3 1.1v-3l13.2-.8.5-13.5s0-6.5-4-6.2l-3-.8.6-13.4-10.7-.1-.6-3.7 1.8-.3.5-6.6-3.8-4.6-2.3 1L471 450l-3.6-.4-3 1.5-9.7-3-7 .5-7.6 7-1.9.5c-1.9-3-6.7.5-6.7.5l.5 5.4 3 .5 1.3 1.9h4.3l-.3 3-4 .5-.3 11.3.5 2.4 2.7-5.1 6.5 5.9 1.1 9.7-11.1-.3v-3l-6.5 5.4-4.6 1.9-.8-3.5-4.3-1.1-1.1 3.2-1.1-2.4-2.8 1.7 3.9 3.9 4.8 5.8 5.1 11.2 3.7 2.7-2 2.7-1 3.1 2.4 1 2 2.7.3 8.2-1.3 3.9 7.4-1.8 1.1-3.6z"
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    id: "N32",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M526.4 479.6H516l.5-14.2-25.2-1 5.6 2.3 2.3 9.4h-3.1v-1.8l-1.8 1.3.3 4.3-10.2-.1-.6 13.4 3 .8c4-.3 4 6.2 4 6.2l-.5 13.5-13.2.8v3l-11.3-1.1-.3 3.8-3.2.8-.8 3.5-6.2.3-.5-8.4-.8-5.4-3.8-1.3-6.5 5.1.3-3.8-4.3 1.9-2.4-4.6-3.5 3.2 2.7 3.2 7.8 10.5-1.1 4.3-2.7.3-1.5 3.2 1.9.8-1.1 4-7.4 1.8-.1.2-.3 6.5 1.4 3.4 4.1-3.7 4.1.3 3.4-1.4 7.5 1 1.7 1.4 3.1-.7 1-2.4 4.4-1 6.5-1 2.4-1 5.4 3.7 1 3.7 7.8 6.1 2.7-1 3.4 2 1.7 2.7 2.7 3.2 5.4-4.3 4.1.4 5.9-3.2 3.6-1.4 2.3-4.5 6.3-5 1.8-7.3.4.2.7.3-.4-57.2z"
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    id: "N33",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M418.5 495.2l1.1-3.2 4.3 1.1.8 3.5 4.6-1.9 6.5-5.4v3l11 .2-1-9.7-6.5-5.9-2.7 5.1-.6-2.4-9.4-.3-2.7-4.3-11.3-.8v-1.9l-6.2-1.1-2.5 9.2-2.5-.2-3 6.3v4.1l4.4-1.7 7.2 1 4 4.1.6.5 2.8-1.7z"
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    id: "N34",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M849.5 440.1l-1.4-6.8 3.6-9.4-14-.8-2-2-2 1.3-8.1-5.8-8.1 2.8-8.1-7.9h-1v-7.1l-66.4-2.5-3.5 3.8.9 1.5 1 4.1 1.5 2.3-.8 4.6-6.1 5.6-1.8 10.7 4.1 5.8 1 3.8 15.5 23.4 14-8.4 11.9-7.9 7.4-.3.8 1.5 6.1-.3 8.1-3.3 2.3 2.3 2-2.5 6.4 3.8.3 7.9-10.2 6.4s-3.3 5.6-7.4 4.1c0 0-5.6 0-6.4 3.6l-3.3 3.3 14.5 11.9 5.8 2.5 10.7 11.4 22.4.8-.2-3.9 5.9-8.2c-2.3-.9-4.5-7.7-4.5-7.7-1.4-3.2 1.4-9.5 1.4-9.5l-3.2-5 3.6-3.2 1.8-5 3.2-3.2v-1.8l2.3-.9 2.7-.9 1.8-4.5.9-4.1-5.4-6.3z"
  }))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    id: "N35",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M806.3 492l-5.8-2.5-14.5-11.9 3.3-3.3c.8-3.6 6.4-3.6 6.4-3.6 4.1 1.5 7.4-4.1 7.4-4.1l10.2-6.4-.3-7.9-6.4-3.8-2 2.5-2.3-2.3-8.1 3.3-6.1.3-.8-1.5-7.4.3L768 459l-14 8.4-15.6-23.4-1-3.8-4.1-5.8 1.8-10.7 6.1-5.6.8-4.6-1.5-2.3-1-4.1-.9-1.5-40.6 45.2-12.4 13.7 3.1.3-.3 7.7 7.2-.3 2 4.6 3.8-1.5 1.5 4.1 5.3 1.3 2.5 6.4 8.9 1.3 2 3.6 2 1 .3 1.8-3.8 4.8-5.1.8-1.3-1-2.8 1.8-2.7 8.3.8-.2 35.3 14-1.4 5.4 72.1 20.4 12.2 1.8 2.7 3.2 1.4-4.5-1.8-2.3 1.4-7.7c1.8-15.9 3.6-11.8 3.6-11.8l1.4-.5 2.7-4.1 4.5-2.7v-6.8l-3.6-5.4-.2-3.8-22.4-.8-10.6-11.7z"
  }))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    id: "N36",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M713.8 499.2l1.3 1 5.1-.8 3.8-4.8-.3-1.8-2-1-2-3.6-8.9-1.3-2.5-6.4-5.3-1.3-1.5-4.1-3.8 1.5-2-4.6-7.2.3-.2 4-2.3 5.8-9.4 1.5-35.6-3.3-3.1.8-1.5-1.8-3.6 5.1-6.1-3.8-1.3 2s-2.9-2.3-5.5-2c-2 .2-3.8 1.8-4.2 7.1l1 2-.5 2 3.8 4.1 4.6 3.1 1 2.8-3.8 5.1 1.5 1.8-2 4.9.7.5 13.7 8.4 24.5 4.5 21.3-11.3 26.9-6.6 2.7-8.3 2.7-1.5z"
  }))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    id: "N1",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M642.6 175.5l-1.5-6.6 1.3-2.8 2.3-.8-1-12.9-47.1-15-4.8-5.8-3.4-4.1-4.8.3-1.4 2-2.4-.3-2.4-2.7-4.4-.3-.3 3.7-.3 2.4-2.4-2.4-7.1.7-6.1 4.4-3.1.7-1.7 4.1-.3 3.7-3.4-2.4-3.7 3.1-3.1-1.7-.3-6.1-2-2v-3.1c4.4-3.7-.3-7.5-.3-7.5-.7-7.1-1.7-6.5-1.7-6.5-2-9.2-8.2-6.1-8.2-6.1l-4.8-1-3.4-.7-4.1 3.1-4.1-3.1-5.1-3.1h-3.4l-6.8-5.4c2.7-.3 1-6.5 1-6.5l-2.7-3.4c-.3-2.4-.3-4.8-.3-4.8l-3.4-.7-5.8 1-3.7-5.4-2.4-1-3.7-2.4-2.4 2.7-.7 4.8-2 2.7-2 .7-4.8 5.1 6.5.3 1 2 1.7 1 1.7 1.4-1.4 3.4 2 2.7 2.7 2 2.7 5.8 1.4 3.4.7 4.1.7 2.7-2 .7.7 6.8-4.1 4.8 2.7 1.4 2.4 10.9 2.7 1.4 1.7 3.4v3.1l4.4 3.4-2 5.1-.7 6.5-6.1 4.1v5.1l3.4 4.4 1.4 6.8 2.4 2.7-1.7 7.8 3.7 3.7-1.4 1.4 1 3.4 2 8.2-2 2.7-4.4-1-6.1 6.5-2-.7-1.7 3.1 2 2.7-2.4 4.1-2.4-1-2 1.7-.3 4.4-.7 4.1-.3 2-2.4 1.7.3 2.7-.1.3 6 2.1 1.3 3.3 1.8-1.5 4.8 1.8-1.3 4.6s14.7 0 18 9.9l-.2.5 8.1 1 9.4-2 3.8.5 2-1.8 1.8 2.5 2.5 1 1.8-1.8v-2l6.1-5.1 5.6.5 1.5-1-1-3.3 1.8-7.6-1.5-2-4.8-6.1s2-4.6 7.1-7.6c5.1-3.1 10.7-2 15-.3 4.3 1.8 7.6.5 8.4-1.5.8-2 3.3-9.7 3.3-9.7s6.4-8.2 13.7-7.1c1 .1 2.1.5 3.1 1l2-.5.3-3.1 4.1-3.1 3.1 1.5 1-1.5-.8-2.5s10.2-3.6 2.8-8.4l2-6.4 2.5-3.1s7.4-1.8 9.2-3.1l14 4.8 2.5 4.3s6.1-3.1 5.3-2.5c-.8.5 3.8-.8 3.8-.8l-.5-3.8 1.5-1.3-.3-3.3s-4.8-1.5-2.5-6.1l4.4-5.2z"
  }))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    id: "N10",
    className: "small-box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M466.4 352l6.1-1.3 1 .8 1.3-4.4 5.8-.8.3-.4 2.3-5.4 4-3.5-3.3-5.1-11.9-.8-8.1-5.1-.6-4.8-5 1-5.6-3.3 1.2-2.8-6.8-9.1-.1.4-69.7-2.1 1.8 27 .6 9.3 11.7-3.1 8.1 3.3 1.3-1 7.4 3.8.2-1 4.6-2.3 3.3 6.6-2 1.8 2.5 6.1 7.7 2.5 5.8-9.4 15.3 7.9 5.8-.3 2.8-1.7 4.5.9.8-.2z"
  }))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    id: "text",
    transform: "matrix(1, 0, 0, 1, -18, 0)"
  }, /*#__PURE__*/React.createElement("text", {
    x: 546.236,
    y: 205.607
  }, "\n      N1\n    "), /*#__PURE__*/React.createElement("text", {
    x: 634.96,
    y: 235.86
  }, "\n      N2\n    "), /*#__PURE__*/React.createElement("text", {
    x: 718.598,
    y: 222.386
  }, "\n      N3\n    "), /*#__PURE__*/React.createElement("text", {
    x: 549.54,
    y: 279.077
  }, "\n      N4\n    "), /*#__PURE__*/React.createElement("text", {
    x: 694.7,
    y: 305.008
  }, "\n      N5\n    "), /*#__PURE__*/React.createElement("text", {
    x: 835.286,
    y: 335.006
  }, "\n      N6\n    "), /*#__PURE__*/React.createElement("text", {
    x: 773.002,
    y: 377.461
  }, "\n      N7\n    "), /*#__PURE__*/React.createElement("text", {
    x: 696.227,
    y: 347.717
  }, "\n      N8\n    "), /*#__PURE__*/React.createElement("text", {
    x: 492.34,
    y: 337.803
  }, "\n      N9\n    "), /*#__PURE__*/React.createElement("text", {
    x: 428.275,
    y: 337.04
  }, "\n      N10\n    "), /*#__PURE__*/React.createElement("text", {
    x: 629.11,
    y: 326.618
  }, "\n      N15\n    "), /*#__PURE__*/React.createElement("text", {
    x: 570.385,
    y: 362.461
  }, "\n      N16\n    "), /*#__PURE__*/React.createElement("text", {
    x: 497.882,
    y: 369.605
  }, "\n      N13\n    "), /*#__PURE__*/React.createElement("text", {
    x: 467.04,
    y: 373.206
  }, "\n      N12\n    "), /*#__PURE__*/React.createElement("text", {
    x: 670.04,
    y: 372.123
  }, "\n      N17\n    "), /*#__PURE__*/React.createElement("text", {
    x: 622.755,
    y: 387.884
  }, "\n      N18\n    "), /*#__PURE__*/React.createElement("text", {
    x: 647.668,
    y: 429.069
  }, "\n      N19\n    "), /*#__PURE__*/React.createElement("text", {
    x: 391.667,
    y: 373.903
  }, "\n      N20\n    "), /*#__PURE__*/React.createElement("text", {
    x: 441.644,
    y: 397.988
  }, "\n      N21\n    "), /*#__PURE__*/React.createElement("text", {
    x: 451.282,
    y: 360.865
  }, "\n      N11\n    "), /*#__PURE__*/React.createElement("text", {
    x: 467.04,
    y: 411.962
  }, "\n      N23\n    "), /*#__PURE__*/React.createElement("text", {
    x: 503.523,
    y: 431.736
  }, "\n      N25\n    "), /*#__PURE__*/React.createElement("text", {
    x: 489.693,
    y: 386.033
  }, "\n      N14\n    "), /*#__PURE__*/React.createElement("text", {
    x: 493.356,
    y: 404.11
  }, "\n      N24\n    "), /*#__PURE__*/React.createElement("text", {
    x: 465.09,
    y: 394.075
  }, "\n      N22\n    "), /*#__PURE__*/React.createElement("text", {
    x: 536.32,
    y: 468.22
  }, "\n      N26\n    "), /*#__PURE__*/React.createElement("text", {
    x: 470.575,
    y: 441.62
  }, "\n      N27\n    "), /*#__PURE__*/React.createElement("text", {
    x: 572.165,
    y: 493.64
  }, "\n      N28\n    "), /*#__PURE__*/React.createElement("text", {
    x: 383.762,
    y: 432.779
  }, "\n      N29\n    "), /*#__PURE__*/React.createElement("text", {
    x: 418.388,
    y: 449.477
  }, "\n      N30\n    "), /*#__PURE__*/React.createElement("text", {
    x: 451.663,
    y: 496.184
  }, "\n      N31\n    "), /*#__PURE__*/React.createElement("text", {
    x: 493.355,
    y: 518.808
  }, "\n      N32\n    "), /*#__PURE__*/React.createElement("text", {
    x: 409.48,
    y: 488.286
  }, "\n      N33\n    "), /*#__PURE__*/React.createElement("text", {
    x: 807.32,
    y: 439.746
  }, "\n      N34\n    "), /*#__PURE__*/React.createElement("text", {
    x: 751.136,
    y: 506.606
  }, "\n      N35\n    "), /*#__PURE__*/React.createElement("text", {
    x: 659.87,
    y: 503.556
  }, "\n      N36\n    "))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDNegerisembilan);
export default __webpack_public_path__ + "static/media/d_negerisembilan.35158610.svg";
export { ForwardRef as ReactComponent };